import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import Survey from './index.vue';
import SurveyMixins from './mixins';

var PreviewSurveyPage = function (_super) {
  __extends(PreviewSurveyPage, _super);

  function PreviewSurveyPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.surveyDetails = _this.initDetails();
    _this.id = '';
    return _this;
  }

  PreviewSurveyPage.prototype.created = function () {
    this.id = this.$route.query.id;
    this.queryQuestionList();
  };

  PreviewSurveyPage.prototype.queryQuestionList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var res, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.id) {
              return [2];
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            this.loading = true;
            this.isSuccessLoad = false;
            return [4, this.$api.survey.queryArkSurveyDetails({
              id: Number(this.id)
            })];

          case 2:
            res = _a.sent();
            this.surveyDetails = res.data;
            this.loading = false;
            this.isSuccessLoad = true;
            return [3, 4];

          case 3:
            error_1 = _a.sent();
            this.loading = false;
            this.isSuccessLoad = false;
            return [3, 4];

          case 4:
            return [2];
        }
      });
    });
  };

  PreviewSurveyPage = __decorate([Component({
    components: {
      Survey: Survey
    }
  })], PreviewSurveyPage);
  return PreviewSurveyPage;
}(Mixins(SurveyMixins));

export default PreviewSurveyPage;